export const scoreFromDb = (results = []) => {
  if (!Array.isArray(results) || results.length === 0) {
    return { TV: 0, CV: 0, HV: 0, MV: 0, LV: 0, SS: 0 };
  }

  const sum = (key) =>
    results.reduce((acc, row) => acc + (parseFloat(row[key]) || 0), 0);

  const TV = sum("t_vul");
  const CV = sum("c_vul");
  const HV = sum("h_vul");
  const MV = sum("m_vul");
  const LV = sum("l_vul");

  const SS = Math.round(sum("ss") / results.length);

  return { TV, CV, HV, MV, LV, SS };
};

export const scoreFromMisconfigDb = (data = []) => {
  const misconfigData = data?.[0]?.misconfig;
  const saveScore = data?.[0]?.ss;

  const summary = misconfigData?.last_run?.summary || {};
  const metrics = Object.values(summary).reduce(
    (acc, item) => {
      const flagged = Number(item.flagged_items) || 0;
      const rules = Number(item.rules_count) || 0;

      if (flagged > 0) {
        acc.critical += flagged;
      } else if (rules > 0) {
        acc.warning += 1;
      } else {
        acc.clean += 1;
      }

      return acc;
    },
    {
      critical: 0,
      warning: 0,
      clean: 0,
    }
  );

  return {
    misconfigAll: metrics,
    ss: saveScore,
  };
};

export const calcBreachProbab = (vulTotal, vulCrit, misTotal, misCrit) => {
  const globalCritical = (vulCrit || 0) + (misCrit || 0);
  const globalTotalAll = (vulTotal || 0) + (misTotal || 0);

  if (globalTotalAll === 0) return { probability: 0, category: "Low" };
  const MAX_CRITICAL_THRESHOLD = 15;
  const COUNT_WEIGHT = 7; 
  const DENSITY_WEIGHT = 3; 
  const volumeFactor = Math.min(1, globalCritical / MAX_CRITICAL_THRESHOLD);
  const densityFactor = globalCritical / globalTotalAll;
  let probability = (volumeFactor * COUNT_WEIGHT) + (densityFactor * DENSITY_WEIGHT);
  probability = Math.min(10, Math.round(probability * 10) / 10);
  let category = "Low";

  if (probability >= 8) category = "Critical";
  else if (probability >= 5) category = "High";
  else if (probability >= 2.5) category = "Medium";

  return { probability, category };
};
